export default __webpack_public_path__ + "static/media/avatar_19.b1c8a364.svg";